import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	prioritySchemeNameFieldPlaceholder: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.name-and-description.priority-scheme-name-field-placeholder',
		defaultMessage: 'Give this priority scheme a unique name',
		description: 'Priority scheme modal name field placeholder text',
	},
	prioritySchemeDescriptionFieldPlaceholder: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.name-and-description.priority-scheme-description-field-placeholder',
		defaultMessage: 'Add more details to identify this scheme',
		description: 'Priority scheme modal description field placeholder text',
	},
	prioritySchemeNameFieldTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.name-and-description.priority-scheme-name-field-title',
		defaultMessage: 'Name',
		description: 'priority scheme modal name field title',
	},
	prioritySchemeDescriptionFieldTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.priority-scheme-details.name-and-description.priority-scheme-description-field-title',
		defaultMessage: 'Description',
		description: 'priority scheme modal description field title',
	},
});

export default messages;
